import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth'

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyD-B_t6Eln9aIkLxiSuJa_0csWsiapb9cw",
    authDomain: "time-machine-9fde9.firebaseapp.com",
    databaseURL: "https://time-machine-9fde9.firebaseio.com",
    projectId: "time-machine-9fde9",
    storageBucket: "time-machine-9fde9.appspot.com",
    messagingSenderId: "887652272734",
    appId: "1:887652272734:web:0921091e6efc2e09ca02cf"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);

  const auth = firebase.auth()
  const db = firebase.firestore();

  export { auth, db }